import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalConfirmComponent } from './modal-confirm.component';
import {BtnCloseModule} from '../../btn-close/btn-close.module';
import {ReactiveFormsModule} from '@angular/forms';



@NgModule({
  declarations: [ModalConfirmComponent],
  imports: [
    CommonModule,
    BtnCloseModule,
    ReactiveFormsModule
  ]
})
export class ModalConfirmModule { }
